// Pinia Store
import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { AnalyticsProduct } from '~~/common/plugins/aw-analytics';

export const useAnalyticsProductListQueueStore = defineStore('analyticsProductListQueue', () => {
  const viewedProductListHistory = ref(new Set<string>());
  const viewItemListQueue = ref(new Map<string, AnalyticsProduct[]>());

  const isProductInViewedHistory = (productId: string, listName: string | null): boolean => {
    return viewedProductListHistory.value.has(`${listName}:${productId}`);
  };

  const addToViewedProductListHistory = (productId: string, listName: string | null): void => {
    viewedProductListHistory.value.add(`${listName}:${productId}`);
  };

  const clearViewedProductListHistory = (): void => {
    viewedProductListHistory.value = new Set();
  };

  const addToViewItemListQueue = (listName: string, item: AnalyticsProduct): void => {
    if (!viewItemListQueue.value.has(listName)) {
      viewItemListQueue.value.set(listName, []);
    }
    viewItemListQueue.value.get(listName)!.push(item);
  };

  const flushViewItemListQueue = (): Map<string, AnalyticsProduct[]> => {
    const snapshot = new Map(viewItemListQueue.value);
    viewItemListQueue.value = new Map();
    return snapshot;
  };

  return {
    viewedProductListHistory,
    viewItemListQueue,
    isProductInViewedHistory,
    addToViewedProductListHistory,
    clearViewedProductListHistory,
    addToViewItemListQueue,
    flushViewItemListQueue,
  };
});
